import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { formatPrice, formatTime } from "@/utils/format";
import "@/styles/index.scss";

Vue.config.productionTip = false;
Vue.use(ElementUI);

Vue.filter("price", formatPrice);
Vue.filter("time", formatTime);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
